class ProductCard extends HTMLElement{
  constructor(){
    super();
    // alert("product card created");
    this.hidden = this.hasAttribute("hidden");
  }


  connectedCallback() {
    this.imageUrls = this.dataset.imageUrls.split("|");
    // console.log(this.imageUrls);
    this.flickity = this.querySelector('flickity-large');
    this.buttons = this.querySelector('card-information-buttons');
    // this.setupMagnifyButton();  
    window.addEventListener("load", () => {
      this.initMagnifyButton(); });
    // if(!this.flickity.hasAttribute("hidden")) {
    //   this.buttons.removeAttribute("hidden");
    // }
  }

  setupMagnifyButton () {
    this.magnifyInitialised = false
    // handle magnify button attachment timing 
    if (this.buttons.magnifyButton) { this.initMagnifyButton(); }
    else if (!this.buttons.magnifyButton) { this.buttons.addEventListener('buttons-ready', () => this.initMagnifyButton()); }
    else { if(this.flickity)this.flickity.addEventListener('urls-ready', () => this.initMagnifyButton()); }
  }

  initMagnifyButton () {
    // this.mfpMetroMag = new MetroMag("mfp-img");

    // // create and attach mfp
    // if (this.buttons.magnifyButton && !this.magnifyInitialised && (this.flickity ? this.flickity.imageUrls : true)) {
    // alert(`magnifyButtonClassName: ${this.buttons.magnifyButton.className} imageUrls ${this.flickity.imageUrls}`);

      this.mfpObj = new MFP(".carousel-cell", "[class*='" + this.buttons.magnifyButton.className + "']", (this.flickity ? this.flickity.flickity : undefined), this.mfpMetroMag, this.imageUrls);
      this.mfpObj.create();

      if(this.flickity) {
        this.flickity.flickity.on('change', (index) =>  {
          this.mfpObj.setIndex(index);
          // flickityMetroMag{{ index }}.removeWrapper();
        });
      }
      this.magnifyInitialised = true;
    
  // }
  // else{this.setupMagnifyButton();}

    // create flickity magnifier when fklickity started
    // flicky.on('settle', function () {
    //   flickityMetroMag{{ index }}.createMagnifier("[class*='flickity-carousel-cell-class-index-{{ index }}_{{ identifier }} carousel-cell is-selected'] > img");
    //   flickityMetroMag.createMagnifier(FLICKITY_PRODUCT_IMAGE_MAIN);
    // });
  }
}

customElements.define('product-card', ProductCard);